import styled, { css } from 'styled-components';

import { ThemeMode } from '@/helpers/enums';

import { device } from '@/styles/helpers';

interface ScBonusCardProps {
  isFlipped?: boolean;
  mode?: ThemeMode;
  withWager: boolean;
  isLongText: boolean;
}

export const ScBonusCard = styled.div<ScBonusCardProps>`
  position: relative;
  width: 100%;
  padding-bottom: 312px;
  transform-style: preserve-3d;
  transform: perspective(2500px) rotateY(0) translateY(0);

  .front,
  .back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    overflow: hidden;
    backface-visibility: hidden;
    transition: transform 0.7s;
    padding: 56px 16px 16px;
    background: ${({ theme }) => theme.grayDarkColor};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;

    .buttons-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
      z-index: 1;
    }
  }

  .front {
    & > .header {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
      height: 44px;
      padding: 0 8px;
      width: max-content;
    }

    & > .info {
      position: relative;
      z-index: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 24px;

      & > .offer-data {
        display: flex;
        flex-direction: column;
        gap: 12px;
        text-transform: uppercase;

        & > .title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: ${({ theme }) => theme.secondaryColor};
          font-weight: 700;
          font-size: 22px;
          line-height: 28px;
          letter-spacing: 0.44px;
        }

        & > .offer {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 700;

          ${({ isLongText }) =>
            isLongText
              ? css`
                  font-size: 22px;
                  line-height: 28px;
                  letter-spacing: 0.44px;
                `
              : css`
                  font-size: 32px;
                  line-height: 40px;
                  letter-spacing: 0.96px;
                `}

          @media (${device.mobile}) {
            ${({ isLongText }) =>
              !isLongText &&
              css`
                font-size: 28px;
                line-height: 36px;
                letter-spacing: 0.84px;
              `}
          }
        }
      }

      & > .progress {
        display: flex;
        flex-direction: column;
        gap: 6px;

        & > .wager {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-weight: 700;
          line-height: 20px;
          gap: 12px;
          white-space: nowrap;

          & > .progress {
            overflow: hidden;
            text-overflow: ellipsis;
          }

          & > .coef {
            color: ${({ theme }) => theme.blackLightColor};
            font-weight: 400;
          }
        }
      }
    }

    .default-bonus-img {
      position: absolute;
      right: 0;
      bottom: 0;
      opacity: ${({ withWager }) => (withWager ? 0.1 : 1)};
      z-index: 0;
    }
  }

  .back {
    transform: rotateY(180deg);

    ul {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      gap: 8px;

      li {
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        display: flex;
        gap: 8px;
        align-items: center;
        flex-wrap: wrap;

        & .bonus-terms {
          max-width: calc(100% - 30px);
        }

        a {
          color: ${({ theme }) => theme.secondaryColor};
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          text-decoration-line: underline;
          transition: 0.2s;

          @media (hover: hover) {
            &:hover {
              color: ${({ theme }) => theme.secondaryColorHover};
            }
          }
        }
      }
    }
  }

  ${({ isFlipped }) =>
    isFlipped &&
    css`
      .front {
        transform: rotateY(180deg);
      }
      .back {
        transform: rotateY(0deg);
      }
    `}
`;
